import React from 'react';

import { Checkbox } from '../ui/checkbox';
import { CATEGORIES_WHATSAPP } from '../../lib/preferencesWhatsapp';
import { libelle } from '../../lib/libelles';

/**
 * Ce que chacun reçoit sur WhatsApp: six familles d'alertes à cocher, puis les
 * heures calmes (« Ne pas me déranger de … à … »).
 *
 * Les cases se rangent en une colonne sur téléphone et en deux au-delà: six
 * cases, donc jamais une case seule sur sa ligne. Les deux heures tiennent
 * toujours sur une seule ligne (grille à trois colonnes), de 320 à 1920 px.
 * Les alertes critiques passent à toute heure, et le dit.
 *
 * Composant de saisie pur: l'état et l'enregistrement restent à `ProfilePage`.
 */
export default function ChoixAlertesWhatsapp({ categories, heuresCalmes, disabled = false, onCategorie, onHeures }) {
  const choix = categories || {};
  const heures = heuresCalmes || { debut: '', fin: '' };

  return (
    <div className="space-y-4" data-testid="choix-alertes-whatsapp">
      <fieldset className="min-w-0 space-y-2.5" disabled={disabled}>
        <legend className="mb-2 text-sm font-semibold text-foreground">
          {libelle('choixAlertesWhatsapp', 'titre')}
        </legend>
        <div className="grid gap-x-6 gap-y-3 sm:grid-cols-2">
          {CATEGORIES_WHATSAPP.map((code) => (
            <div key={code} className="flex items-start gap-2.5">
              <Checkbox
                id={`whatsapp-categorie-${code}`}
                checked={Boolean(choix[code])}
                disabled={disabled}
                onCheckedChange={(coche) => onCategorie?.(code, coche === true)}
                aria-describedby={`whatsapp-categorie-${code}-aide`}
                className="mt-0.5"
              />
              <div className="min-w-0">
                <label
                  htmlFor={`whatsapp-categorie-${code}`}
                  className="cursor-pointer text-sm font-medium text-foreground"
                >
                  {libelle('categorieAlerteWhatsapp', code)}
                </label>
                <p id={`whatsapp-categorie-${code}-aide`} className="text-xs text-muted-foreground">
                  {libelle('categorieAlerteWhatsappAide', code)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </fieldset>

      <div role="group" aria-labelledby="whatsapp-calme-titre">
        <p id="whatsapp-calme-titre" className="text-sm font-semibold text-foreground">
          {libelle('choixAlertesWhatsapp', 'calme_titre')}
        </p>
        <div className="mt-2 grid max-w-xs grid-cols-[1fr_auto_1fr] items-center gap-2">
          <input
            id="whatsapp-calme-debut"
            type="time"
            className="input-base"
            aria-label={libelle('choixAlertesWhatsapp', 'calme_debut')}
            value={heures.debut || ''}
            disabled={disabled}
            onChange={(e) => onHeures?.({ ...heures, debut: e.target.value })}
          />
          <span className="text-sm text-muted-foreground" aria-hidden="true">
            {libelle('choixAlertesWhatsapp', 'calme_a')}
          </span>
          <input
            id="whatsapp-calme-fin"
            type="time"
            className="input-base"
            aria-label={libelle('choixAlertesWhatsapp', 'calme_fin')}
            value={heures.fin || ''}
            disabled={disabled}
            onChange={(e) => onHeures?.({ ...heures, fin: e.target.value })}
          />
        </div>
        <p className="mt-1.5 text-xs text-muted-foreground">{libelle('choixAlertesWhatsapp', 'calme_aide')}</p>
      </div>
    </div>
  );
}
